import styled from 'styled-components/macro'
import { Box, Checkbox, Stack } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const StackMotion = motion(Stack)
const BoxMotion = motion(Box)

export const StyledTabs = styled(BoxMotion)`
  position: relative;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32%;
  border-radius: 12px 12px 0 0;
  cursor: pointer;
    --bg: ${({ $bg }) => $bg};
    --r: 16px;
    background: var(--bg) !important;
    border-radius: var(--r) var(--r) 0 0 !important;
    &::before,
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        width: var(--r);
        height: var(--r);
        pointer-events: none;
    }

    &::before {
        right: 100%;
        background: radial-gradient(circle at 0 0, transparent calc(var(--r) - 0.5px), var(--bg) var(--r));
    }

    &::after {
        left: 100%;
        background: radial-gradient(circle at 100% 0, transparent calc(var(--r) - 0.5px), var(--bg) var(--r));
    }
`
